// Manage flow of all booker authorization screens here
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AccountInfo from './AccountInfo';
import Authorize from './Authorize';
import Configure from './Configure';
import SetupSuccess from './SetupSuccess';

export default class ZenotiSetup extends Component {
  constructor() {
    super();

    this.state = {
      isAccountInfoSaved: false,
      isSetupComplete: false,
      isAuthorized: false,
      staffCredSaved:false,
      isLocationSelected:false,
      isReferralAvailable:false,
      isConfigureSetup:false,
      configureData:{}
    };

    this.handleBackAction = this.handleBackAction.bind(this);
  }
  
  componentWillReceiveProps(nextProps) {
    const { softwares: prevSoftwares } = this.props;
    const { softwares: newSoftwares, zenotiAuthType } = nextProps;

    const newState = {};

    console.log('prevSoftwares , newSoftwares', prevSoftwares, newSoftwares);
    // isSavingZenotiAccountInfo: false,
    // isZenotiAccountInfoSaveSuccess: true,
    // isZenotiAccountInfoSaveFail: false,
    // if (prevSoftwares.isZenotiAccountInfoSaveSuccess) {
    //   newState.isAccountInfoSaved = true;
    // }

    // if (
    //   prevSoftwares.isSavingZenotiAccountInfo &&
    //   !newSoftwares.isSavingZenotiAccountInfo &&
    //   newSoftwares.isZenotiAccountInfoSaveSuccess
    //   && newSoftwares.zenotiStaffCredLogin
    // ) {
    //   newState.isAccountInfoSaved = true;
    // }
    // if (
    //   prevSoftwares.isZenotiStaffLogin &&
    //   !newSoftwares.isZenotiStaffLogin &&
    //   newSoftwares.isZenotiAccountInfoSaveSuccess
    //   && newSoftwares.zenotiStaffCredLogin
    // ) {
    //   newState.isAccountInfoSaved = true;
    // }

    if (!prevSoftwares.isZenotiAccountInfoSaveSuccess && newSoftwares.isZenotiAccountInfoSaveSuccess){
      newState.isAccountInfoSaved = true;
    }

    if (!prevSoftwares.isZenotiConfigureSetup && newSoftwares.isZenotiConfigureSetup){
      newState.isConfigureSetup= true;
    }


    if (prevSoftwares.isZenotiAutorization && !newSoftwares.isZenotiAutorization) {
      newState.isSetupComplete = true;
    }

    // if (prevSoftwares.isZenotiAutorization && !newSoftwares.isZenotiAutorization) {
    //   newState.isSetupComplete = true;
    // }
    console.log('prevSoftwares',prevSoftwares);
    console.log('newSoftwares',newSoftwares);
    if(!prevSoftwares.zenotiStaffCredLogin && newSoftwares.zenotiStaffCredLogin){
      newState.staffCredSaved = true
    }
    if (Object.keys(newState).length) {
      this.setState(newState);
    }
  }

  handleBackAction(screen) {
    if (screen === 'authorize') {
      this.setState({
        isAccountInfoSaved: false,
        isConfigureSetup:false,
        staffCredSaved:false,
        isReferralAvailable:false
      });
    }else if(screen === 'accountinfo'){
      this.setState({
        isAccountInfoSaved: false,
        isConfigureSetup:false,
        staffCredSaved:false,
        isReferralAvailable:false
      });
    }else if(screen === 'configure'){
      this.setState({
        isAccountInfoSaved: true,
        isConfigureSetup:false,
        staffCredSaved:true,
        isReferralAvailable:false
      });
    }else if(screen === 'referral'){
      this.setState({
        isAccountInfoSaved: true,
        isConfigureSetup:false,
        staffCredSaved:true,
        isReferralAvailable:false
      });
    }
  }
  saveConfigureData=(data)=>{
    this.setState({
      isConfigureSetup:true,
      configureData:data,
      staffCredSaved:false
    });
    this.props.onZenotiConfigureSetup();
  }
  saveReferral=(data)=>{
    const configData = {...this.state.configureData,...data};
    this.setState({
      configureData:configData,
      isReferralAvailable:true,
    });
    this.props.onZenotiReferral();
  }
  render() {
    const { router, zenotiAuthType, onzenotiAuthTypeChange } = this.props;
    const { isAccountInfoSaved, isSetupComplete, configureData, isConfigureSetup } = this.state;
    if (isSetupComplete) {
      // Show setup success screen
      return (
        <SetupSuccess
          onDone={() => {
            // Get Bookings Software Info
            this.props.getBookingSoftware();

            // Redirect to summary screen
            this.props.history.push('/app/setup');
          }}
          {...this.props}
        />
      );
    }
    if(isConfigureSetup){
      return (
        <Authorize
          onBack={() => {
            this.handleBackAction('configure');
          }}
          {...this.props}
          configureData={configureData}
        />
      );
    }

    if (isAccountInfoSaved) {
      if(this.props.softwares.brand){
        return (
          <Authorize
          onBack={() => {
            this.handleBackAction('accountinfo');
          }}
          {...this.props}
          configureData={configureData}
        />
        );
      }

      else{
        return (
          <Configure
            onBack={() => {
              this.handleBackAction('accountinfo');
            }}
            saveConfigureData={this.saveConfigureData}
            {...this.props}
          />
        );
      }
    }

    return <AccountInfo {...this.props} zenotiAuthType={zenotiAuthType} onzenotiAuthTypeChange={onzenotiAuthTypeChange}/>;
  }
}

ZenotiSetup.propTypes = {
  getBookingSoftware: PropTypes.func.isRequired,
  softwares: PropTypes.shape().isRequired,
  router: PropTypes.shape().isRequired,
};
